import { createSlice } from '@reduxjs/toolkit';
import { BannerProductPageResponse } from '../../types/bannerProductPage';

interface BannerProductPageState {
  data: Partial<BannerProductPageResponse>;
  submitSuccess?: boolean;
}

const initialState: BannerProductPageState = {
  data: {},
  submitSuccess: false,
};

export const slice = createSlice({
  name: 'bannerProductPageSlice',
  initialState,
  reducers: {
    setBannerProductPageList(state, action) {
      state.data = action.payload;
    },
    setSubmitSuccess(state, action) {
      state.submitSuccess = action.payload.submitSuccess;
    },
  },
});

export const { setBannerProductPageList, setSubmitSuccess } = slice.actions;
export default slice.reducer;
